import React, { useRef, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";

import { ImportDialogContent } from "../ImportDialog";
import { getWhatnotIntegrations } from "src/store/plaidIntegration/selector";
import { usePreventImportWhatnot } from "../usePreventImportWhatnot";
import { whatnotSyncSales } from "src/store/integrationSync/actions/whatnot";

import DialogTitle from "../DialogTitle";
import type Step from "../Step";

interface WhatnotImportProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
}

export function useIntegration() {
  const integration = useSelector((s) => {
    const integrations = getWhatnotIntegrations(s as any);
    if (integrations) {
      let integration = integrations[0];
      for (const i of integrations) {
        if ((i.createdAt || 0) > (integration.createdAt || 0)) integration = i;
      }
      return integration;
    }
  });
  const integrationId = integration?.id;

  return {
    integrationId,
  };
}

function WhatnotImport({ onClose, onStepChange }: WhatnotImportProps) {
  const dispatch = useDispatch();
  const { integrationId } = useIntegration();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const dialogTitle = useMemo(() => {
    return (props) => (
      <DialogTitle onClose={() => onCloseRef.current()} {...props} />
    );
  }, []);
  const [memory] = useState(() => ({
    integrationId,
  }));

  return (
    <>
      <ImportDialogContent
        DialogTitle={dialogTitle}
        onClose={() => {
          onStepChange("whatnot:import-in-process");
        }}
        providerName="Whatnot"
        integrationId={memory.integrationId || ""}
        actions={
          <Button
            color="primary"
            onClick={() => onStepChange("whatnot:do-you-sell-on-whatnot")}
          >
            Continue Set-up
          </Button>
        }
        disableInventory
        fetchTransactions={async (integrationId, start, end) => {
          dispatch(whatnotSyncSales(integrationId, { start, end }));
          return { success: true };
        }}
        usePreventImport={usePreventImportWhatnot}
      />
    </>
  );
}

export default WhatnotImport;
